import * as React from "react";

const badgeClassName = "tw-h-auto tw-w-full";

export const RewardsBadgeA = () => (
  <img
    src="/media/enterprise/g2-leader-fall-2025.png"
    alt="G2 Leader Fall 2025 badge"
    loading="lazy"
    className={badgeClassName}
    draggable={false}
  />
);

export const RewardsBadgeB = () => (
  <img
    src="/media/enterprise/g2-highest-adoption-2025.png"
    alt="G2 Highest User Adoption 2025 badge"
    loading="lazy"
    className={badgeClassName}
    draggable={false}
  />
);

export const RewardsBadgeC = () => (
  <img
    src="/media/enterprise/g2-easiest-setup-fall-2025.png"
    alt="G2 Easiest Setup Fall 2025 badge"
    loading="lazy"
    className={badgeClassName}
    draggable={false}
  />
);
